
import { Button } from "@/components/ui/button";
import { PlusCircle } from "lucide-react";

interface EmptyGroupsStateProps {
  onCreateGroup: () => void;
}

const EmptyGroupsState = ({ onCreateGroup }: EmptyGroupsStateProps) => {
  return (
    <div className="text-center py-12">
      <h3 className="text-lg font-medium text-gray-600 dark:text-gray-300 mb-4">
        No groups created yet
      </h3>
      <p className="text-gray-500 dark:text-gray-400 mb-6">
        Create groups to organize your products
      </p>
      <Button 
        className="bg-blue-500 hover:bg-blue-600"
        onClick={onCreateGroup}
      >
        <PlusCircle className="mr-2 h-4 w-4" />
        Create Your First Group
      </Button>
    </div>
  );
};

export default EmptyGroupsState;
